module.exports = __webpack_public_path__ + "img/loader-black.6f9b9110.svg";